import { media, styled } from '@styles';
import pensileImage from 'images/pensile.svg';

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: #2c2c2c;
  mix-blend-mode: normal;
  opacity: 0;
  transition: 0.3s;
`;

export const Bottom = styled.div`
  padding: 24px;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  ${media.largeScreen`
    padding: 20px;
  `}
  ${media.mediumScreen`
    padding: 15px;
  `}
  ${media.xSmallScreen`
    padding: 10px;

    flex-direction: column;
    align-items: start;
  `}
`;

export const Customize = styled.span`
  display: block;
  position: absolute;
  right: 50%;
  transform: translateX(50%);
  top: 1px;

  color: #ffffff;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
  top: calc(50% + 30px);

  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  line-height: 160%;
`;

export const Pensile = styled.div`
  transition: 0.3s;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: #4f6e7c;
  position: absolute;
  bottom: 20px;
  right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;

  transform-origin: 68px 68px;
  ${media.largeScreen`
    transform: scale(calc(40 / 48)); // 40 18
  `}
  ${media.mediumScreen`
    transform: scale(calc(30 / 48)); // 30 13
  `}
  ${media.xSmallScreen`
    transform: scale(calc(20 / 48)); // 30 9
  `}
  &::after {
    content: '';
    width: 38%;
    height: 38%;
    background-image: url(${pensileImage});
  }
`;

export const Category = styled.p`
  font-size: ${(props) => props.theme.typography.labelFontSize};
  font-family: ${(props) => props.theme.typography.extraFontFamily};
  line-height: ${(props) => props.theme.typography.labelFontSize};
  color: #839098;
  text-transform: capitalize;
  text-align: left;
  margin-top: 9px;
  ${media.xSmallScreen`
    margin: 0;
  `}
`;

export const Wrapper = styled.div`
  margin: auto;
  background: #f5f1f2;
  text-align: center;
  // max-height: 32rem;
  height: 100%;
  transition: 0.3s;
  max-width: 342px;
  ${media.mediumScreen`
    // max-width: 272px;
  `}
  ${media.mediumScreen`
    max-width: 100%;
  `}

  @media (hover: hover) {
    :hover {
      background-color: #ffffff;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);
      ${Overlay} {
        opacity: 0.6;
      }
      ${Pensile} {
        right: 50%;
        bottom: calc(50% + 30px);
        transform-origin: center;
        background: #c34c3e;

        transform: translate(50%, 50%) scale(calc(82 / 48));
        ${media.largeScreen`
          transform: translate(50%, 50%) scale(calc(64 / 48));
        `}
      }
      ${Customize} {
        opacity: 1;
      }
    }
  }
`;

export const Title = styled.h4`
  font-weight: 300;
  line-height: 100%;
  color: #2c2c2c;
  text-transform: capitalize;
  width: 50%;
  text-align: left;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-family: ${(props) => props.theme.typography.baseFontFamily};
  ${media.xSmallScreen`
    width: 100%;
  `}
`;

export const Price = styled.p`
  font-size: ${(props) => props.theme.typography.extraFontFamily};
  font-family: ${(props) => props.theme.typography.smallFontSize};
  line-height: 160%;
  color: #4f6e7c;
  width: 50%;
  text-align: right;
  ${media.xSmallScreen`
    text-align: left;
    order: 1;
  `}
`;

export const Image = styled.div`
  position: relative;
  width: auto;
  height: auto;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;

  // height: 372px;
  ${media.largeScreen`
    // height: 318px;
  `}
  ${media.mediumScreen`
    // height: 239px;
  `}
  ${media.xSmallScreen`
    // height: 159px;
  `}

  > img {
    width: 100%;
    mix-blend-mode: multiply;
  }
`;
